<template>
<div style="height: 60px;width: 100%;background: #f3e04c;" class="f-l fdqx-b fdqy-c">
	<div style="height: 60px;">
		<img src="../../../public/img/责任大成立德树人(1).gif" height="90px" class="ml10" style="margin-top: -10px;">
	</div>
	<div>
		<time-show></time-show>
	</div>
	<div style="width: 450px;">
		<my-user></my-user>
	</div>
</div>
</template>

<script>

import TimeShow from "./timeShow.vue";
import MyUser from "./user.vue";
export default {
	components:{
		TimeShow,
		MyUser
	},
	created() {
		
	}
}
</script>

<style>
</style>
